const headerWithToken = {
    headers: {
      'Content-Type': 'Application/json'
    },
  }
export default headerWithToken;